import PremiumStarIcon from './PremiumStarIcon';

export default PremiumStarIcon;
